import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import { log, Style } from "./helpers";
var LOCAL_STORAGE_KEYS = {
    CART_ID: "bf_cartId",
    JWT: "bf_jwt",
    GROUP_ID: "bf_groupId",
    LOOKUP_ID: "bf_lookupId",
    PROMO: "bf_promo",
    PROMO_SLIPSTREAM: "bf_promo_slipstream",
    ACCESS: "bf_access",
    EMAIL: "bf_email",
    NAME: "bf_name",
    AUTOREG_TERMS: "bf_autoreg_terms",
    DEVICE_ID: "bf_device_id",
    HAS_DISMISSED_AST_COACHMARK: "bf_coachmark",
    REDIRECT_VALUES: "bf_redirect_values",
    QUERY_VALUES: "bf_query_values",
    ORIGINAL_ORDER_ID: "bf_orig_order",
    ALLOW_EXPIRE: "bf_allow_expire",
    REMOVED_PROMOS: "bf_removed_promos",
};
var setLocal = function (key, value, expirationSeconds) {
    var encodedValue = encodeURIComponent(value);
    var expiration = expirationSeconds
        ? moment()
            .add(expirationSeconds, "seconds")
            .toISOString()
        : "0";
    var encodedExpiration = encodeURIComponent(expiration);
    var encodedString = "".concat(encodedValue, "[~bf~]").concat(encodedExpiration);
    window.self.localStorage.setItem(key, btoa(encodedString));
};
var getLocal = function (key) {
    var val = window.self.localStorage.getItem(key);
    if (val) {
        var decodedVal = decodeURIComponent(atob(val));
        var payload = decodedVal.split("[~bf~]");
        if (payload[1] === "0" || moment().isBefore(moment(payload[1]))) {
            return payload[0];
        }
        else {
            return null;
        }
    }
    else {
        return null;
    }
};
var removeLocal = function (key) {
    //eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
    if (window.brushfireDebugMode) {
        log("Cleared ".concat(key, " from local storage"), Style.base);
    }
    window.self.localStorage.removeItem(key);
};
var getCartId = function (eventNumber) {
    var key = "".concat(LOCAL_STORAGE_KEYS.CART_ID, "-").concat(eventNumber);
    var cartId = getLocal(key);
    if (!cartId) {
        var newCartId = "".concat(moment().format("yyyyMMDD"), "-").concat(uuidv4().replaceAll("-", ""));
        setLocal(key, newCartId, 60 * 60 * 24 * 30);
        return newCartId;
    }
    else {
        return cartId;
    }
};
var getDeviceId = function () {
    var deviceId = getLocal(LOCAL_STORAGE_KEYS.DEVICE_ID);
    if (!deviceId) {
        var newDeviceId = uuidv4().replaceAll("-", "");
        setLocal(LOCAL_STORAGE_KEYS.DEVICE_ID, newDeviceId);
        return newDeviceId;
    }
    else {
        return deviceId;
    }
};
var localTest = function () {
    var val = Math.random().toString();
    try {
        setLocal("cookie-test", val);
        var fetch_1 = getLocal("cookie-test");
        if (fetch_1 === val) {
            removeLocal("cookie-test");
            return true;
        }
        else {
            removeLocal("cookie-test");
            return false;
        }
    }
    catch (_a) {
        // just swallow it
        return false;
    }
};
export { LOCAL_STORAGE_KEYS, setLocal, getLocal, getCartId, removeLocal, getDeviceId, localTest };
